import * as Sentry from "@sentry/browser";
import { captureStack } from "integrations/sentry";

import {
  INCREMENT_LOAD_COUNT,
  SET_LOADER_PROGRESS,
  SET_LOADER_TEXT,
} from "./actions";

const initialState = {
  loadCount: 0,
  loaderText: null,
  progress: null,
};

function loaderReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_LOADER_PROGRESS:
      return {
        ...state,
        progress: payload.progress,
      };
    case INCREMENT_LOAD_COUNT: {
      const loadCount = state.loadCount + payload.loadCount;
      if (loadCount < 0) {
        const warning =
          "Warning: loadCount would be less than 0, setting to 0 instead.";

        console.warn(warning);

        captureStack();
        Sentry.captureMessage(warning, Sentry.Severity.Warning);
      }

      return {
        ...state,
        loadCount: Math.max(0, loadCount),
      };
    }
    case SET_LOADER_TEXT:
      return {
        ...state,
        loaderText: payload.loaderText,
      };
    default:
      return state;
  }
}

export { loaderReducer };
